import { theme } from '~/theme';

export const tableRowHeight = 48;

export const useSxStyles = () => {
  return {
    refDiv: {
      display: 'flex',
      flexGrow: 1,
    },
    contentPadding: {
      padding: theme.spacing(0, 2),
    },
    tableContainer: {
      overflowY: 'hidden',
      overflowX: 'auto',
      width: '100%',
      '& tbody tr': { height: tableRowHeight },
    },
    table: {
      tableLayout: 'fixed',
    },
  };
};
